export default {"src":"/bnb/_next/static/media/message-dark.a6687b0a.svg","height":48,"width":53};